import type { IExtractRouteParamMap } from "@/routes";
import { createPaths } from "@routes/utils";

const baseRoute = `/channel-management`;

export const channelManagementRoutesObj = {
  list: baseRoute,
  view: `${baseRoute}/view/:channelId`,
  edit: `${baseRoute}/edit/:channelId`,
} as const;

export type IChannelManagementRouteParams = IExtractRouteParamMap<
  typeof channelManagementRoutesObj
>;

export const channelManagementPath = createPaths<
  typeof channelManagementRoutesObj,
  IChannelManagementRouteParams
>(channelManagementRoutesObj);
